export enum EventStatus {
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED',
}

export enum EventVisibility {
  PUBLIC = 'PUBLIC',
  MEMBERS_ONLY = 'MEMBERS_ONLY',
}

export type TicketedEventTicketType = {
  id: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
  deletedBy: string | null;
  name: string;
  description: string | null;
  price: number;
  available: number;
  sortOrder: number;
  ticketedEventId: string;
};

export type TicketedEventCategory = {
  id: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
  deletedBy: string | null;
  name: string;
  description: string | null;
};

export type TicketedEventTag = {
  id: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
  deletedBy: string | null;
  name: string;
  description: string | null;
};

export type TicketedEventOrganizer = {
  id: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
  deletedBy: string | null;
  name: string;
  email: string | null;
  phone: string | null;
  website: string | null;
};

export type TicketedEventCategories = {
  id: string;
  ticketedEventId: string;
  categoryId: string;
  category?: TicketedEventCategory;
  createdAt: string;
  deletedAt: string | null;
};

export type TicketedEventTags = {
  id: string;
  ticketedEventId: string;
  tagId: string;
  tag?: TicketedEventTag;
  createdAt: string;
  deletedAt: string | null;
};

export type TicketedEventOrganizers = {
  id: string;
  ticketedEventId: string;
  organizerId: string;
  organizer?: TicketedEventOrganizer;
  createdAt: string;
  deletedAt: string | null;
};

import type { Asset } from './assets';
import type { Venue } from './venue';
import type { Purchase } from './purchase';

export type TicketedEvent = {
  id: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
  deletedBy: string | null;
  archivedAt: string | null;
  archivedBy: string | null;
  name: string;
  slug?: string | null;
  description: string;
  teaser: string | null;
  startDateTime: string | null;
  endDateTime: string | null;
  capacity: number;
  visibility: EventVisibility;
  status: EventStatus;
  featuredImageId: string | null;
  featuredImage?: Asset;
  images?: Asset[];
  ticketTypes?: TicketedEventTicketType[];
  tickets?: TicketedEventTicket[];
  categories?: TicketedEventCategories[];
  tags?: TicketedEventTags[];
  organizers?: TicketedEventOrganizers[];
  venueId: string;
  venue?: Venue;
};

export type TicketedEventTicket = {
  id: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
  deletedBy: string | null;
  ticketTypeId: string;
  ticketType?: TicketedEventTicketType;
  fishId: string;
  eventId: string;
  event?: TicketedEvent;
  purchaseId: string | null;
  purchase?: Purchase;
};
